(function () {
    function rgb(value) {
        const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(value.trim());
        if (hex) {
            const text = hex[1].length === 3 ? [...hex[1]].map(c => c + c).join('') : hex[1];
            return [0, 2, 4].map(index => parseInt(text.slice(index, index + 2), 16)).concat(1);
        }
        const match = /^rgba?\(([^)]+)\)$/.exec(value.trim());
        if (!match) return null;
        const channels = match[1].split(/[,\s/]+/).filter(Boolean).map(Number);
        return channels.length >= 3 && channels.every(Number.isFinite) ? channels.slice(0, 3).concat(channels[3] === undefined ? 1 : channels[3]) : null;
    }

    function luminance(color) {
        return color.slice(0, 3).reduce((sum, channel, index) => {
            const value = channel / 255;
            const linear = value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
            return sum + linear * [0.2126, 0.7152, 0.0722][index];
        }, 0);
    }

    function ratio(a, b) {
        const light = luminance(a), dark = luminance(b);
        return (Math.max(light, dark) + 0.05) / (Math.min(light, dark) + 0.05);
    }

    function foreground(background) {
        return ratio([0, 0, 0], background) >= ratio([255, 255, 255], background) ? '#000' : '#fff';
    }

    function background(element) {
        if (!element) return null;
        const layers = [];
        const view = element.ownerDocument.defaultView;
        for (let parent = element; parent; parent = parent.parentElement) {
            const style = view.getComputedStyle(parent);
            if (style.backgroundImage !== 'none') return null;
            const color = rgb(style.backgroundColor);
            if (!color) return null;
            layers.unshift(color);
            if (color[3] === 1) break;
        }
        return layers.reduce((result, color) => color.slice(0, 3).map((channel, index) => channel * color[3] + result[index] * (1 - color[3])), [255, 255, 255]);
    }

    const accent = rgb(getComputedStyle(document.documentElement).getPropertyValue('--ghost-accent-color'));
    if (!accent) return;
    document.documentElement.style.setProperty('--accent-foreground', foreground(accent));
    document.querySelectorAll('.gh-post-upgrade-cta-content').forEach(panel => {
        const color = background(panel);
        if (color) {
            panel.style.setProperty('--membership-foreground', foreground(color));
            panel.style.setProperty('--membership-line', luminance(color) < 0.5 ? '#3f3f46' : '#d4d4d8');
        }
    });

    const frames = new WeakMap();
    function attach(frame) {
        let doc;
        try { doc = frame.contentDocument; } catch { return; }
        if (!doc || frames.get(frame) === doc) return;
        frames.set(frame, doc);
        let pending = false;
        function refresh() {
            pending = false;
            if (!doc.head || !doc.defaultView) return;
            doc.querySelectorAll('.gh-portal-btn').forEach(control => {
                control.toggleAttribute('data-title-case', ['Sign up', 'Sign in'].includes(control.textContent.trim()));
            });
            const button = doc.querySelector('.gh-portal-btn-primary');
            const link = doc.querySelector('.gh-portal-btn-link');
            const buttonBackground = background(button);
            const linkBackground = background(link);
            const surface = background(doc.querySelector('.gh-portal-popup-container'));
            const dark = surface && luminance(surface) < 0.5;
            const line = dark ? '#3f3f46' : '#d4d4d8';
            const focus = dark ? '#d4d4d8' : '#52525b';
            let css = `.gh-portal-popup-container { border: 1px solid ${line} !important; border-radius: 14px !important; }`;
            css += `.gh-portal-input { border: 1px solid ${line} !important; border-radius: 8px !important; background-color: ${dark ? '#27272a' : '#f4f4f5'} !important; }`;
            css += `.gh-portal-btn-primary { border: 1px solid ${line} !important; border-radius: 8px !important; font-weight: 500 !important; }`;
            css += `.gh-portal-input:focus, .gh-portal-btn:focus-visible { outline: 2px solid ${focus} !important; outline-offset: 2px; }`;
            css += '.gh-portal-btn[data-title-case] { text-transform: capitalize !important; }';
            if (buttonBackground) {
                css += `.gh-portal-btn-primary { color: ${foreground(buttonBackground)} !important; }`;
                css += '.gh-portal-btn-primary .gh-portal-loadingicon { color: inherit !important; }';
                css += '.gh-portal-btn-primary .gh-portal-loadingicon path, .gh-portal-btn-primary .gh-portal-loadingicon rect { fill: currentColor !important; }';
            }
            if (linkBackground) {
                const color = ratio(accent, linkBackground) >= 4.5 ? `rgb(${accent.slice(0, 3).join(',')})` : foreground(linkBackground);
                css += `.gh-portal-btn-link { color: ${color} !important; }`;
            }
            let style = doc.getElementById('source-portal-contrast');
            if (!css && !style) return;
            if (!style) {
                style = doc.createElement('style');
                style.id = 'source-portal-contrast';
                doc.head.appendChild(style);
            }
            if (style.textContent !== css) style.textContent = css;
        }
        const observer = new MutationObserver(() => {
            if (!pending) {
                pending = true;
                requestAnimationFrame(refresh);
            }
        });
        observer.observe(doc, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style']});
        refresh();
    }

    const watched = new WeakSet();
    function watchFrames() {
        document.querySelectorAll('iframe[title="portal-popup"], iframe.gh-portal-popupiframe').forEach(frame => {
            if (!watched.has(frame)) {
                watched.add(frame);
                frame.addEventListener('load', () => attach(frame));
            }
            attach(frame);
        });
    }
    new MutationObserver(watchFrames).observe(document.documentElement, {childList: true, subtree: true});
    watchFrames();
})();
